import { render } from "./AllBillingInvoicesPage.vue?vue&type=template&id=3038f53b&scoped=true"
import script from "./AllBillingInvoicesPage.vue?vue&type=script&lang=js"
export * from "./AllBillingInvoicesPage.vue?vue&type=script&lang=js"

import "./AllBillingInvoicesPage.vue?vue&type=style&index=0&id=3038f53b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3038f53b"]])

export default __exports__